import { useNavigate } from 'react-router';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { Botao, Cartao, Selo } from '../../../web/src/componentes/base';
import { Estado } from '../../../web/src/componentes/estados';
import { useToast } from '../../../web/src/componentes/toast';
import { mensagemDeErro } from '../../../web/src/nucleo/api';
import { pget, ppost } from '../api';

interface Empresa {
  acesso_id: string;
  parceiro_nome: string;
  workspace_nome: string;
  papel: string;
  atual: boolean;
}

/** Várias empresas por login: troca a empresa da sessão (o resto do app passa a mostrar só a escolhida). */
export function Empresas() {
  const { t } = useTranslation('portal');
  const qc = useQueryClient();
  const navegar = useNavigate();
  const toast = useToast();
  const q = useQuery({ queryKey: ['portal', 'empresas'], queryFn: () => pget<{ itens: Empresa[] }>('/sessao/empresas') });
  return (
    <div className="flex flex-col gap-4">
      <div>
        <h1 className="text-2xl font-bold tracking-tight">{t('empresas.titulo')}</h1>
        <p className="mt-1 text-sm text-tinta-2">{t('empresas.texto')}</p>
      </div>
      <Cartao semPadding>
        <Estado consulta={q}>
          {(d) => (
            <ul className="divide-y divide-borda">
              {d.itens.map((e) => (
                <li key={e.acesso_id} className="flex items-center gap-3 px-4 py-3">
                  <div className="min-w-0 flex-1">
                    <p className="truncate text-sm font-medium">{e.parceiro_nome}</p>
                    <p className="truncate text-xs text-tinta-3">
                      {e.workspace_nome} · {t(`papel.${e.papel}`)}
                    </p>
                  </div>
                  {e.atual ? (
                    <Selo cor="acento">{t('empresas.atual')}</Selo>
                  ) : (
                    <Botao
                      tamanho="sm"
                      onClick={async () => {
                        try {
                          await ppost('/sessao/empresa', { acesso_id: e.acesso_id });
                          qc.clear();
                          navegar('/', { replace: true });
                        } catch (err) {
                          toast.erro(mensagemDeErro(err));
                        }
                      }}
                    >
                      {t('empresas.escolher')}
                    </Botao>
                  )}
                </li>
              ))}
            </ul>
          )}
        </Estado>
      </Cartao>
    </div>
  );
}
